/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} N_Items_SelectedInputs */

const en_n_items_selected = /** @type {(inputs: N_Items_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} items selected`)
};

const nl_n_items_selected = /** @type {(inputs: N_Items_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} items geselecteerd`)
};

/**
* | output |
* | --- |
* | "{count} items selected" |
*
* @param {N_Items_SelectedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const n_items_selected = /** @type {((inputs: N_Items_SelectedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<N_Items_SelectedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_n_items_selected(inputs)
	return en_n_items_selected(inputs)
});